// src/hooks/useApi.js

import { useState, useEffect, useCallback } from 'react';

/**
 * Hook personnalisé pour gérer les appels API avec état de chargement et d'erreur
 * @param {Function} apiFunction - Fonction d'API à appeler
 * @param {Array} dependencies - Dépendances qui déclenchent un nouvel appel API
 * @param {boolean} immediate - Si true, l'appel est effectué immédiatement au montage
 * @param {any} initialData - Données initiales avant la réponse de l'API
 */
const useApi = (apiFunction, dependencies = [], immediate = true, initialData = null) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(immediate);
  const [error, setError] = useState(null);

  const execute = useCallback(async (...params) => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiFunction(...params);
      setData(response.data);
      setLoading(false);
      return { success: true, data: response.data };
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Une erreur est survenue');
      setLoading(false);
      return { success: false, error: err };
    }
  }, [apiFunction]);

  useEffect(() => {
    if (immediate) {
      execute();
    }
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps

  return { data, loading, error, execute, setData };
};

export default useApi;